module.exports = __webpack_public_path__ + "static/media/financepic4@2x.6aba1712.png";